import type { UserReturnDto } from '@skillarea/lib-shared';

export const DOB_ROUTE_PATH = '/account/dob';

export function isDobGateRequired(
  user: UserReturnDto | null | undefined,
): boolean {
  return Boolean(
    user && (!user.dateOfBirth || user.regData?.requiresDateOfBirth === true),
  );
}

export function isDobGateProtectedPath(pathname: string): boolean {
  return pathname !== DOB_ROUTE_PATH;
}

export function getDobRedirectTarget(locationHref: string): string {
  const locationUrl = new URL(locationHref, 'https://skillarea.local');
  return `${locationUrl.pathname}${locationUrl.search}${locationUrl.hash}`;
}

export function normalizeDobRedirectTarget(
  value: string | null | undefined,
): string {
  if (!value || !value.startsWith('/') || value.startsWith('//')) {
    return '/';
  }

  if (value === DOB_ROUTE_PATH || value.startsWith(`${DOB_ROUTE_PATH}?`)) {
    return '/';
  }

  return value;
}
